import React from 'react';
import {preventDefaultDrag} from '../../Utils/utils';
import NextVideoTimer from './NextVideoTimer';

class AuditoriumNextVideoTimer extends React.Component {
    render() {
        const {
            timeSlot,
            translation,
            auditoriumTimeslots,
            currentTimeSlotIndex,
            auditoriumProgramHasEnded,
            auditoriumHasVideos,
            totalSecondsTillNextVideo,
        } = this.props;

        const isLastTimeSlot = currentTimeSlotIndex === auditoriumTimeslots.length - 1;

        return (
            <div onDragStart={preventDefaultDrag} className="next-video">
                <div onDragStart={preventDefaultDrag} className="next-video-container">
                    {timeSlot?.imageUrl ? (
                        <div onDragStart={preventDefaultDrag} className="timeslot-background-image">
                            <img
                                draggable="false"
                                onDragStart={preventDefaultDrag}
                                src={timeSlot.imageUrl}
                                alt="current program"
                            />
                        </div>
                    ) : (
                        <>
                            {auditoriumProgramHasEnded ? (
                                <p onDragStart={preventDefaultDrag} className="auditorium-program-ended-text">
                                    {translation?.auditorium.noVideos}
                                </p>
                            ) : (
                                <>
                                    {auditoriumTimeslots.length > 0 && auditoriumHasVideos ? (
                                        <p>
                                            {isLastTimeSlot ? (
                                                <span> {translation?.auditorium.noVideos}</span>
                                            ) : (
                                                <NextVideoTimer
                                                    totalSecondsTillNextVideo={totalSecondsTillNextVideo}
                                                    loadCurrentTimeSlot={this.props.loadCurrentTimeSlot}
                                                />
                                            )}
                                        </p>
                                    ) : (
                                        <p>
                                            <span>{translation?.auditorium.noVideos}</span>
                                        </p>
                                    )}
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
        );
    }
}

export default AuditoriumNextVideoTimer;
